module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Alisha Ramasar is a unique hybrid of a sunshine-yellow and cool-blue-personality. She is an award-winning International Cannes Lion advertising agency recipient. She has the ability to conceptualise, visualise, optimise and quite frankly, kick some ass into gear. She is an innovator, a strategist, a fashionable-foodie-fanatic that loves to add something special to simply…‘doing’. She is a proud wife and a mummy of two princess-superhero girls who inspired this entire book. She aspires to take a break and rest, but somehow keeps on agreeing to do more sh*t that gets in the way of her taking a break and resting.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0